export default function Compounds() {
  return <div>TODO:Compounds</div>;
}
